import { Actions, ActionTypes } from '@appStore/metering-points/actions';

export interface State {
    taxReturnAgreementCreated: boolean;
    createTaxReturnAgreementLoading: boolean;
    createTaxReturnAgreementLoaded: boolean;
    createTaxReturnAgreementId: number;
    activeAgreementLink: string;
    activeAgreementLinkLoading: boolean;
    activeAgreementLinkLoaded: boolean;
}

export const initialState: State = {
    taxReturnAgreementCreated: false,
    createTaxReturnAgreementLoading: false,
    createTaxReturnAgreementLoaded: false,
    createTaxReturnAgreementId: null,
    activeAgreementLink: null,
    activeAgreementLinkLoading: false,
    activeAgreementLinkLoaded: false
}

export function reducer(state = initialState, action: Actions): State {
    switch(action.type) {
        case ActionTypes.CreateTaxReturnAgreement:
            return {...state, taxReturnAgreementCreated: false, 
                createTaxReturnAgreementLoading: true, 
                createTaxReturnAgreementLoaded: false, 
                createTaxReturnAgreementId: null };
        case ActionTypes.CreateTaxReturnAgreementSuccess:
            return {...state, taxReturnAgreementCreated: true, 
                createTaxReturnAgreementLoading: false, 
                createTaxReturnAgreementLoaded: true, 
                createTaxReturnAgreementId: action.payload };
        case ActionTypes.CreateTaxReturnAgreementFail:
            return {...state, taxReturnAgreementCreated: false, 
                createTaxReturnAgreementLoading: false, 
                createTaxReturnAgreementLoaded: false, 
                createTaxReturnAgreementId: null };
        case ActionTypes.AgreementLinkLoad:
            return {...state, activeAgreementLink: null, activeAgreementLinkLoaded: false, activeAgreementLinkLoading: true };
        case ActionTypes.AgreementLinkLoadSuccess:
            return {...state, activeAgreementLink: action.payload, activeAgreementLinkLoaded: true, activeAgreementLinkLoading: false };
        case ActionTypes.AgreementLinkLoadFail:
            return {...state, activeAgreementLink: null, activeAgreementLinkLoaded: false, activeAgreementLinkLoading: false };
    }
    
    return state;
}

export const getTaxReturnAgreementCreated = (state: State) => state.taxReturnAgreementCreated;
export const getTaxReturnAgreementCreateId = (state: State) => state.createTaxReturnAgreementId;
export const getActiveAgreementLink = (state: State) => state.activeAgreementLink;
export const getActiveAgreementLinkLoaded = (state: State) => state.activeAgreementLinkLoaded;